import type { PaymentReceiptRow } from '../utils/payment-receipt-view.util';

type PaymentReceiptSummaryProps = {
  rows: PaymentReceiptRow[];
};

export function PaymentReceiptSummary({ rows }: PaymentReceiptSummaryProps) {
  if (rows.length === 0) return null;

  return (
    <section
      aria-labelledby='payment-receipt-summary'
      className='rounded-2xl border border-alba-gray-200 bg-white px-4 py-2'
    >
      <h2
        id='payment-receipt-summary'
        className='py-2 text-sm font-semibold text-alba-black-500'
      >
        Resumo do seu seguro
      </h2>
      <dl className='divide-y divide-alba-gray-200'>
        {rows.map(row => (
          <div
            key={row.label}
            className='flex items-baseline justify-between gap-4 py-2.5'
          >
            <dt className='shrink-0 text-sm text-alba-gray-500'>{row.label}</dt>
            <dd className='min-w-0 text-right text-sm font-semibold break-words text-alba-gray-700'>
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
